import { Link } from 'react-router-dom'
import { Box, SxProps } from '@mui/material'

const logoBlack =
    'https://assets.asktia.com/images/pastel_rebrand/logo-black.svg'
const logoWhite =
    'https://assets.asktia.com/images/pastel_rebrand/logo-white.svg'

interface TiaLogoProps {
    link?: string
    sx?: SxProps
    variant?: 'black' | 'white'
}

const defaultStyle: SxProps = {
    maxHeight: { xs: '24px', md: '32px' }
}

export const TiaLogo = ({
    link = '/',
    variant = 'white',
    sx
}: TiaLogoProps) => {
    return (
        <Link to={link}>
            <Box
                component="img"
                src={variant === 'black' ? logoBlack : logoWhite}
                alt="Tia Logo"
                aria-label="Navigate to Member Home"
                sx={{ ...defaultStyle, ...sx }}
            />
        </Link>
    )
}
